<template>
  <div class="flex h-screen bg-gray-100">
    <!-- Sidebar (conservé tel quel) -->
    <aside class="nav-container w-64 bg-blue-900 text-white flex flex-col p-4 space-y-8">
      <div class="flex items-center">
        <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 mr-2">
        <h1 class="text-1xl font-bold font-serif">AdminGate</h1>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im34.png" class="h-6 w-6 mr-2">
        <router-link to="/dash" class="hover:bg-blue-900 p-2 rounded transition">Dashboard</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im36.png" class="h-6 w-6 mr-2">
        <router-link to="/student" class="hover:bg-blue-900 p-2 rounded transition">Étudiants</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/icour.png" class="h-6 w-6 mr-2">
        <router-link to="/study" class="hover:bg-blue-900 p-2 rounded transition">Cours</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im35.png" class="h-6 w-6 mr-2">
        <router-link to="/event" class="hover:bg-blue-900 p-2 rounded transition">Calendrier</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im33.png" class="h-6 w-6 mr-2">
        <router-link to="/note" class="hover:bg-blue-900 p-2 rounded transition">Évaluations</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im38.png" class="h-6 w-6 mr-2">
        <router-link to="/" class="hover:bg-blue-900 p-2 rounded transition">Logout</router-link>
      </div>
    </aside>

    <!-- Main Content -->
    <main class="flex-1 p-6 overflow-y-auto bg-gray-50">
      <div class=" mb-8">
        <h1 class="flex justify-center text-3xl text-blue-900 font-serif">Tableau de Bord Administratif</h1>
        <p class="text-gray-900 font-serif">Aperçu global du système</p>
      </div>

      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        
        <div class="bg-white p-6 h-[120px] rounded-lg shadow-md border-l-4 border-blue-900">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-900 text-blue-600 mr-4">
              <img src="/image/im36.png" class="h-6 w-6" alt="Étudiants">
            </div>
            <div>
              <p class="text-gray-900 font-serif">Étudiants</p>
              <h3 class="text-2xl font-serif font-bold">{{ stats.etudiants }}</h3>
              <p class="text-sm text-blue-900 font-serif">+5% ce mois</p>
            </div>
          </div>
        </div>

       
        <div class="bg-white p-6 h-[120px] rounded-lg shadow-md border-l-4 border-blue-900">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-900 text-green-600 mr-4">
              <img src="/image/icour.png" class="h-6 w-6" alt="Cours">
            </div>
            <div>
              <p class="text-gray-500 font-serif">Cours</p>
              <h3 class="text-2xl font-serif font-bold">{{ stats.cours }}</h3>
              <p class="text-sm text-blue-900 font-serif">3 nouveaux</p>
            </div>
          </div>
        </div>

        <!-- Carte Évaluations -->
        <div class="bg-white p-6 h-[120px] rounded-lg shadow-md border-l-4 border-blue-900">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-900 text-yellow-600 mr-4">
              <img src="/image/im33.png" class="h-6 w-6" alt="Évaluations">
            </div>
            <div>
              <p class="text-gray-500 font-serif">Évaluations</p>
              <h3 class="text-2xl font-serif font-bold">{{ stats.evaluations }}</h3>
              <p class="text-sm text-blue-900 font-serif">{{ stats.evaluationsEnRetard }} 10 ce mois-ci</p>
            </div>
          </div>
        </div>

        <!-- Carte Moyenne Générale -->
        <div class="bg-white p-6 h-[120px] rounded-lg shadow-md border-l-4 border-blue-900">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-900 text-white mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
              </svg>
            </div>
            <div>
              <p class="text-gray-500  font-serif">Moyenne Générale</p>
              <h3 class="text-2xl font-serif font-bold">{{ stats.moyenneGenerale }}/100</h3>
              <!--  <p class="text-xs font-serif" :class="stats.moyenneGenerale >= 50 ? 'text-green-600' : 'text-red-600'">
                {{ stats.moyenneGenerale >= 50 ? 'Bonne performance' : 'Attention nécessaire' }}
              </p> -->
            </div>
          </div>
        </div>
      </div>

     
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        
        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl text-blue-900 font-serif">Classement des élèves</h2>
            <router-link to="/student" class="text-sm text-blue-900 hover:underline hover:text-blue-700 font-serif">Voir tout</router-link>
          </div>
          <div class="overflow-x-auto">
            <table class="min-w-full font-serif">
              <thead>
                <tr class="text-left border-b">
                  <th class="pb-2">Nom</th>
                  <th class="pb-2">Prenom</th>
                  <th class="pb-2">Niveau</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="evals in dernieresEvaluations" :key="evals.id" class="border-b hover:bg-gray-50">
                  <td class="py-3">{{ evals.nom }}</td>
                  <td class="py-3">{{ evals.prenom }}</td>
                  <td class="py-3">{{ evals.niveau }}</td>
          
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Prochains événements -->
        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl text-blue-900 font-serif">Derniers cours ajoutés</h2>
            <router-link to="/study" class="text-sm text-blue-900 hover:underline hover:text-blue-700 font-serif">Voir plus</router-link>
          </div>
          <ul class="space-y-4">
            <li v-for="event in prochainsEvents" :key="event.id" class=" pl-4 py-2">
              <div class="flex justify-between font-serif">
                <h3 class="font-medium font-serif">{{ event.titre }}</h3>
                <span class="text-sm text-gray-500 font-serif">{{ formatDate(event.start) }}</span>
              </div>
              <p class="text-xs text-gray-600 font-serif">{{ event.prof }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="max-w-4xl mx-auto space-y-8 font-serif mt-10">
        <div>
          <div class="flex justify-center font-serif">
            <img src="/image/im42.png" class="h-8 w-8 mr-2" />
            <h2 class="text-3xl text-blue-900 mb-4">Gestion des Annonces</h2>
          </div>

          <h2 class="text-1xl font-bold mb-4">Créer une annonce</h2>
          <form @submit.prevent="isEditing ? modifierAnnonce() : ajouterAnnonce()" class="grid grid-cols-1 gap-4 p-6 rounded shadow">
            <textarea 
              v-model="form.message" 
              placeholder="Message de l'annonce*" 
              required 
              rows="4"
              class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none"
            ></textarea>
              <div class="flex flex-col items-center">
  <label for="niveau" class="mb-1 text-white">Niveau</label>
  <select 
    id="niveau"
    v-model="form.niveau" 
    class="border p-2 h-[50px] rounded border-b-2 border-gray-300 bg-transparent focus:outline-none"
  >
    <option value="">Tous les niveaux</option>
    <option value="1">1</option>
    <option value="2">2</option>
    <option value="3">3</option>
  </select>
</div>


            <div class="col-span-2 flex justify-center">
              <button 
                type="submit" 
                class="w-[100px] h-8 bg-blue-900 text-white rounded hover:bg-blue-800 transition duration-300"
              >
                {{ isEditing ? "Modifier" : "Publier" }}
              </button>
              <button 
                v-if="isEditing" 
                type="button" 
                @click="annulerModification" 
                class="ml-4 w-[100px] h-8 bg-gray-500 text-white rounded hover:bg-gray-600 transition duration-300"
              >
                Annuler
              </button>
            </div>
          </form>
        </div>

        <div>
          <h2 class="text-1xl font-bold mb-4">Annonces publiées</h2>

          <table class="min-w-full bg-white rounded shadow font-serif">
            <thead>
              <tr class="bg-blue-900 text-white text-left">
                <th class="py-2 px-4">Message</th>
                <th class="py-2 px-4">Niveau</th>
                <th class="py-2 px-4">Date</th>
                <th class="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="annonce in annoncesList" 
                :key="annonce.id" 
                class="border-b hover:bg-gray-50"
                :class="{ 'bg-gray-100': !annonce.read_at }"
              >
                <td class="py-2 px-4">{{ annonce.message }}</td>
                <td class="py-2 px-4">{{ annonce.niveau || 'Tous' }}</td>
                <td class="py-2 px-4">{{ formatDate(annonce.created_at) }}</td>
                
                <td class="py-4 px-4 flex space-x-4">
                  <button @click="editerAnnonce(annonce)">
                    <img src="/image/im40.png" alt="Modifier" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                  <button @click="supprimerAnnonce(annonce.id)">
                    <img src="/image/im41.png" alt="Supprimer" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
    </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  
  data() {
    return {

      form: {
        id: null,
        message: '',
        niveau: ''
      },
      annoncesList: [],
      isEditing: false,

      stats: {
        etudiants: 4,
        cours: 8,
        evaluations: 25,
        moyenneGenerale: 72
      },
      dernieresEvaluations: [
        { id: 1, nom: "DANY", prenom: "Serena", niveau: 3 },
        { id: 2, nom: "EDOH", prenom: "Ashley", niveau: 2 },
        { id: 3, nom: "CULLEN", prenom: "Edward", niveau: 1 },
    
      ],
      prochainsEvents: [
        { 
          id: 1, 
          titre: "Data analyse", 
          start: "2025-06-15 09:00:00", 
          prof: "Mr Aomine", 
          
        },
        { 
          id: 2, 
          titre: "Cours linux", 
          start: "2025-06-10 14:00:00", 
          prof: "Mr Gojo", 
          
        },
        { 
          id: 3, 
          titre: "Framework", 
          start: "2025-07-10 14:00:00", 
          prof: "Mr Geto", 
         
        }
      ]
    }
  },

    mounted() {
    this.getAnnonces()
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    getAnnonces() {
      axios.get('https://mida-back.onrender.com/api/annonces', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(response => {
        this.annoncesList = response.data
      })
      .catch(err => {
        console.error('Erreur récupération annonces', err)
        if (err.response.status === 401) {
          this.$router.push('/login')
        }
      })
    },

    ajouterAnnonce() {
      if (!this.form.message) {
        alert("Le message est obligatoire")
        return
      }

      axios.post('https://mida-back.onrender.com/api/annonces', this.form, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(() => {
        alert('Annonce publiée avec succès !')
        this.reinitialiserForm()
        this.getAnnonces()
      })
      .catch(error => {
        alert('Erreur lors de la publication')
        console.error(error.response.data)
      })
    },

    editerAnnonce(annonce) {
      this.isEditing = true
      this.form = { ...annonce }
    },

    modifierAnnonce() {
      if (!this.form.message) {
        alert("Le message est obligatoire")
        return
      }

      if (!confirm("Voulez-vous vraiment modifier cette annonce ?")) return

      axios.put(`https://mida-back.onrender.com/api/annonces/${this.form.id}`, this.form, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(() => {
        alert('Annonce modifiée avec succès !')
        this.reinitialiserForm()
        this.getAnnonces()
        this.isEditing = false
      })
      .catch(error => {
        alert('Erreur lors de la modification')
        console.error(error.response.data)
      })
    },

    supprimerAnnonce(id) {
      if (!confirm("Voulez-vous vraiment supprimer cette annonce ?")) return

      axios.delete(`https://mida-back.onrender.com/api/annonces/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(() => {
        alert('Annonce supprimée avec succès !')
        this.annoncesList = this.annoncesList.filter(a => a.id !== id)
      })
      .catch(error => {
        alert('Erreur lors de la suppression')
        console.error(error.response.data)
      })
    },

    marquerCommeLue(id) {
      axios.post(`https://mida-back.onrender.com/api/annonces/${id}/mark-as-read`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(() => {
        this.getAnnonces()
      })
      .catch(error => {
        console.error('Erreur marquage comme lue', error)
      })
    },

    annulerModification() {
      this.isEditing = false
      this.reinitialiserForm()
    },

    reinitialiserForm() {
      this.form = {
        id: null,
        message: '',
        niveau: ''
      }
    }
  
  }
}
</script>

<style scoped>
.nav-container {
  background-color: #163767;
}

/* Animation pour les cartes */
.card-hover:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}
</style>